import React, {useEffect, useState} from 'react';
import {Platform, View} from 'react-native';
import Screen from '../../shared/components/screen';
import {CustomScrollView} from '../../shared/components/scrollView';
import {Text} from '../../shared/components/text';
import {Routes, Screens} from '../../shared/routing';
import {Breadcrumbs} from '../../shared/components/breadcrumbs';
import {useStyles} from '../../shared/hooks/styles';
import {DeviceSize, maxDesktopContentWidth, useDeviceSize} from '../../shared/theme/helpers';
import {ResponsiveView} from '../../shared/components/responsiveView';
import {ContentWithRightImage} from '../../shared/components/contentWithRightImage';
import {Image} from '../../shared/components/image';
import {Markdown} from '../../shared/components/markdown';
import {ProductsList} from './ProductsList/ProductsListIndex';
import {PointsCard} from './PointsCard/PointsCard';
import {ProductsCategoryFilter} from './filters/productCategoryFilter';
import {useIsDesktop} from '../../shared/hooks/useIsDesktop';
import {useSelector} from 'react-redux';
import {useAppDispatch} from '../../redux';
import {HistoryTable} from './HistoryTable/HistoryTable';
import {ProductsAcceptorFilter} from './filters/productAcceptorFilter';
import {ProductsListRequestPayload} from '../../shared/models/api/productsListRequestPayload';
import {setProductsByFilters} from '../../redux/actions/products';
import {convertToIDArray} from './filters/pipes';
import {ProductsAcceptorFilterForm, ProductsCategoryFilterForm, ProductsPriceFilterForm} from './filters/model';
import {ProductsPriceFilter} from './filters/priceFilter';
import {SearchBar} from './SearchBar/SearchBar';
import {RewardShopPng} from '../../assets/images';
import {RouteProp, useNavigation, useRoute} from '@react-navigation/native';
import {contentSelector} from '../../redux/selectors/resources';
import {getFormValues} from 'redux-form';
import {Forms} from '../../shared/models/forms';
import {Button} from '../../shared/components/button';
import {themeSelector} from '../../redux/selectors/runtime/theme';

export function RewardShop() {
  const routes = [
    {
      title: 'Возможности карты',
      routeName: Screens.CardServices,
      webRoute: Routes.cardService,
    },
    {
      title: 'Магазин поощрений',
      routeName: Screens.RewardShop,
      webRoute: Routes.rewardShop,
    },
  ];

  const [isProductsWindowShow, setIsProductsWindowShow] = useState(true);
  const [isStoryShow, setIsStoryShow] = useState(false);
  const isDesktop = useIsDesktop();
  const content = useSelector(contentSelector());

  const themeSettings = useSelector(themeSelector());
  const isColorsInvertedVisuallyImpaired =
    themeSettings.switchColor === 'invert' && themeSettings.visuallyImpaired === 1;

  const styles = useStyles(({theme, mediaOnly, deviceSize}) => ({
    root: {
      width: '100%',
      flexDirection: 'column',
      justifyContent: 'flex-start',
      alignItems: 'center',
    },
    upperSection: {
      marginTop: isDesktop ? 30 : 10,
      backgroundColor: theme.screen.container[deviceSize].backgroundColor,
      ...mediaOnly(DeviceSize.mobile, {paddingHorizontal: 16}, {}),
      ...mediaOnly(DeviceSize.tablet, {paddingHorizontal: 35}, {}),
      ...mediaOnly(DeviceSize.desktop, {paddingHorizontal: 60, marginBottom: 40}, {}),
    },
    rightImage: mediaOnly(DeviceSize.desktop, {}, {right: -24, bottom: -74}),

    contentTextWrapper: {
      maxWidth: '90%',
      ...mediaOnly(DeviceSize.desktop, {marginBottom: 0}, {marginBottom: 30}),
    },
    lowerSectionBG: {
      ...mediaOnly(DeviceSize.tablet, {
        flexDirection: 'column',
        justifyContent: 'flex-start',
        alignItems: 'center',
        alignSelf: 'center',
      }),
      minHeight: 900,
      width: `100%`,
      backgroundColor: `white`,
      paddingBottom: 100,
    },
    lowerSection: {
      marginTop: isDesktop ? 30 : 10,
      ...mediaOnly(
        DeviceSize.mobile,
        {
          flexDirection: 'column',
          justifyContent: 'flex-start',
          alignItems: 'center',
          alignSelf: 'center',
          paddingHorizontal: 16,
        },
        {},
      ),
      ...mediaOnly(
        DeviceSize.tablet,
        {
          flexDirection: 'column',
          justifyContent: 'flex-start',
          alignItems: 'center',
          alignSelf: 'center',
          paddingHorizontal: 35,
        },
        {},
      ),
      ...mediaOnly(
        DeviceSize.desktop,
        {
          flexDirection: 'row',
          justifyContent: 'space-between',
          alignItems: 'flex-start',
          alignSelf: 'center',
          paddingHorizontal: 60,
        },
        {},
      ),
    },
    lowerSectionLeft: {
      ...mediaOnly(DeviceSize.mobile, {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
      }),
      ...mediaOnly(DeviceSize.tablet, {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
      }),
      ...mediaOnly(DeviceSize.desktop, {
        width: maxDesktopContentWidth - 540,
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        justifyContent: 'flex-start',
      }),
    },
    tabsContainer: {
      ...mediaOnly(DeviceSize.desktop, {display: 'flex', flexDirection: 'row'}),
      ...mediaOnly(DeviceSize.mobile, {display: 'flex', flexDirection: 'column'}),
    },
    showcaseBtnContainer: {
      ...mediaOnly(DeviceSize.tablet, {flex: 2, marginLeft: 10}, {}),
    },
    showcaseBtn: {
      ...mediaOnly(DeviceSize.mobile, {justifyContent: 'space-evenly'}),
      color: isProductsWindowShow ? theme.color.primaryColor : theme.color.nonActiveCheckBoxColor,
      ...mediaOnly(DeviceSize.mobile, {marginVertical: 20}),
      ...mediaOnly(DeviceSize.tablet, {marginTop: 20}),
      backgroundColor: isColorsInvertedVisuallyImpaired && isProductsWindowShow ? 'black' : 'white',
    },
    title: {
      ...mediaOnly(DeviceSize.desktop, {flex: 1.5, marginTop: 40, marginBottom: 30}, {}),
      ...mediaOnly(DeviceSize.tablet, {flex: 2, marginLeft: 10}, {}),
    },
    tableBtnContainer: {
      ...mediaOnly(DeviceSize.tablet, {flex: 2, marginLeft: 10}),
      ...mediaOnly(DeviceSize.desktop, {marginLeft: 20}),
    },
    tableBtn: {
      ...mediaOnly(DeviceSize.mobile, {justifyContent: 'space-evenly'}),
      color: isStoryShow ? theme.color.primaryColor : theme.color.nonActiveCheckBoxColor,
      ...mediaOnly(DeviceSize.mobile, {marginBottom: 20}),
      ...mediaOnly(DeviceSize.tablet, {marginBottom: 20, marginTop: 20}),
      backgroundColor: isColorsInvertedVisuallyImpaired && isStoryShow ? 'black' : 'white',
    },
    searchBar: {
      ...mediaOnly(DeviceSize.mobile, {marginTop: 20}),
      ...mediaOnly(DeviceSize.tablet, {marginTop: 40}),
      ...mediaOnly(DeviceSize.desktop, {marginRight: 40, marginTop: 20, minWidth: maxDesktopContentWidth - 560}),
    },
    productListContainer: {
      backgroundColor: theme.color.whiteTextColor,
      ...mediaOnly(DeviceSize.mobile, {paddingHorizontal: 16, alignSelf: 'center'}, {}),
      ...mediaOnly(DeviceSize.tablet, {paddingHorizontal: 25, alignSelf: 'center'}, {}),
      ...mediaOnly(DeviceSize.desktop, {width: maxDesktopContentWidth - 550}, {maxWidth: 350}),
    },
    tableContainer: {
      ...mediaOnly(DeviceSize.mobile, {paddingHorizontal: 16}, {}),
      ...mediaOnly(DeviceSize.tablet, {paddingHorizontal: 25}, {}),
      ...mediaOnly(DeviceSize.desktop, {width: maxDesktopContentWidth - 550}, {}),
    },
    lowerSectionRight: {
      flexDirection: 'row',
      flexWrap: 'wrap',
      ...mediaOnly(DeviceSize.mobile, {justifyContent: 'center', width: '15%'}, {}),
      ...mediaOnly(DeviceSize.tablet, {justifyContent: 'center', width: '15%'}),
      ...mediaOnly(DeviceSize.desktop, {justifyContent: 'flex-start', marginRight: 150, width: '15%'}, {}),
    },
    productsContainer: {},
    sidePanel: {
      width: 342,
      ...mediaOnly(DeviceSize.mobile, {margin: 'auto'}, {}),
      ...mediaOnly(DeviceSize.tablet, {marginTop: 10}, {}),
      ...mediaOnly(DeviceSize.desktop, {marginTop: 10}, {}),
    },
    programContentWithImageIcon: {
      marginTop: 50,
      marginRight: 105,
      width: 397,
      height: 352,
    },
    programContentWithImageBackground: {
      ...mediaOnly(DeviceSize.desktop, {top: 25, right: 54, width: 524, height: 536}, {}),
    },
    programContentWithImageContent: {
      ...mediaOnly(DeviceSize.mobile, {minHeight: 1}, {minHeight: 'auto'}),
      ...mediaOnly(DeviceSize.desktop, {minHeight: 450}, {}),
    },
    tabletLayoutBtns: {},
    filterButtonContainer: {
      marginTop: 5,
      paddingVertical: 12,
      paddingHorizontal: 0,
      justifyContent: 'center',
      alignItems: 'center',
      borderTopWidth: 1,
      borderStyle: 'solid',
      borderTopColor: theme.color.borderColor,
    },
    filterButton: mediaOnly(DeviceSize.mobile, {width: '100%'}, {width: 328}),
  }));

  const deviceSize = useDeviceSize();
  const [upperSectionWidth, setUpperSectionWidth] = useState(0);

  const dispatch = useAppDispatch();
  type FilterState = {
    categoriesFilter: ProductsCategoryFilterForm;
    acceptorsFilter: ProductsAcceptorFilterForm;
    priceFilter: ProductsPriceFilterForm;
  };
  const [filter, setFilter] = useState<FilterState>({
    categoriesFilter: {
      productCategory: [],
    },
    acceptorsFilter: {
      productAcceptor: [],
    },
    priceFilter: {
      productPrice: [],
    },
  });

  const productAcceptorFormValues = useSelector(
    getFormValues(Forms.productsAcceptorFilterForm),
  ) as ProductsAcceptorFilterForm;

  const productCategoryFormValues = useSelector(
    getFormValues(Forms.productsCategoryFilterForm),
  ) as ProductsCategoryFilterForm;

  const productPriceFormValues = useSelector(getFormValues(Forms.productsPriceFilterForm)) as ProductsPriceFilterForm;

  let priceFrom: number | undefined;
  if (
    filter.priceFilter !== undefined &&
    filter.priceFilter.productPrice !== undefined &&
    filter.priceFilter?.productPrice[0] !== undefined
  )
    priceFrom = filter.priceFilter?.productPrice[0];

  let priceTo: number | undefined;
  if (
    filter.priceFilter !== undefined &&
    filter.priceFilter.productPrice !== undefined &&
    filter.priceFilter?.productPrice[1] !== undefined
  )
    priceTo = filter.priceFilter?.productPrice[1];

  const navigation = useNavigation();

  const dataForBackEnd: ProductsListRequestPayload = {
    categoriesFilter: convertToIDArray(filter.categoriesFilter?.productCategory ?? []),
    acceptorsFilter: convertToIDArray(filter.acceptorsFilter?.productAcceptor ?? []),
    priceFilterFrom: priceFrom,
    priceFilterTo: priceTo,
  };

  const handlePressShow = () => {
    setFilter((prevFilter) => ({...prevFilter, acceptorsFilter: productAcceptorFormValues}));
    setFilter((prevFilter) => ({...prevFilter, categoriesFilter: productCategoryFormValues}));
    setFilter((prevFilter) => ({...prevFilter, priceFilter: productPriceFormValues}));
    Platform.OS !== 'web' && navigation.goBack();
  };

  useEffect(() => {
    dispatch(setProductsByFilters(dataForBackEnd));
  }, [filter]);

  const handleProductsPress = () => {
    setIsProductsWindowShow(true);
    setIsStoryShow(false);
    dispatch(setProductsByFilters(dataForBackEnd));
  };
  const handleStoryPress = () => {
    setIsProductsWindowShow(false);
    setIsStoryShow(true);
  };

  type RewardShopRouteParams = {
    tabId: string;
  };
  type RewardShopRouteProp = RouteProp<{RewardShop: RewardShopRouteParams}, 'RewardShop'>;
  const route = useRoute<RewardShopRouteProp>();
  useEffect(() => {
    if (route.params?.tabId) {
      handleProductsPress();
    }
  }, [route]);

  return (
    <Screen fullWidth>
      <CustomScrollView contentInsetAdjustmentBehavior='automatic'>
        <View style={styles.root}>
          <View
            style={styles.upperSection}
            onLayout={(event) => {
              const {width} = event.nativeEvent.layout;
              setUpperSectionWidth(width);
            }}>
            <Breadcrumbs routes={routes} />
            <ContentWithRightImage
              icon={<Image source={RewardShopPng as any} width={450} height={400} />}
              hideImage={deviceSize !== DeviceSize.desktop}
              iconStyle={styles.programContentWithImageIcon}
              backgroundStyle={styles.programContentWithImageBackground}
              contentStyle={styles.programContentWithImageContent}>
              <ResponsiveView only={[DeviceSize.desktop]}>
                <Text style={styles.title} type='h2'>
                  {content.services.rewardShop.cardTitle}
                </Text>
              </ResponsiveView>
              <View style={styles.contentTextWrapper}>
                <Markdown listColumns={deviceSize === DeviceSize.desktop ? 2 : 1}>
                  {content.services.rewardShop.descriptionMarkdown}
                </Markdown>
              </View>
            </ContentWithRightImage>
          </View>
          <View style={styles.lowerSectionBG}>
            <View style={[styles.lowerSection, {width: upperSectionWidth}]}>
              <View style={styles.lowerSectionLeft}>
                <View style={styles.tabsContainer}>
                  <View style={styles.showcaseBtnContainer}>
                    <Text style={styles.showcaseBtn} type={isDesktop ? 'h2' : 'h3'} onPress={handleProductsPress}>
                      Витрина
                    </Text>
                  </View>
                  <View style={[styles.tableBtnContainer]}>
                    <Text style={styles.tableBtn} type={isDesktop ? 'h2' : 'h3'} onPress={handleStoryPress}>
                      История
                    </Text>
                  </View>
                </View>
                <View style={[styles.searchBar]}>
                  <SearchBar />
                </View>
                {isProductsWindowShow ? (
                  <View testID='productsView' style={styles.productListContainer}>
                    <ProductsList />
                  </View>
                ) : null}
                {isStoryShow ? (
                  <View testID='tableView' style={styles.tableContainer}>
                    <HistoryTable />
                  </View>
                ) : null}
              </View>

              <View style={styles.lowerSectionRight}>
                <View style={styles.sidePanel}>
                  <PointsCard />
                  {isProductsWindowShow && (
                    <>
                      <ProductsCategoryFilter />
                      <ProductsAcceptorFilter />
                      <ProductsPriceFilter />
                      <View style={[styles.filterButtonContainer]}>
                        <Button
                          id='filter-show'
                          text='Показать'
                          type='secondary'
                          style={styles.filterButton}
                          onPress={handlePressShow}
                        />
                      </View>
                    </>
                  )}
                </View>
              </View>
            </View>
          </View>
        </View>
      </CustomScrollView>
    </Screen>
  );
}
